'use client'
import { assertPackageVersion } from '@dynamic-labs/assert-package-version';
import { version } from '../package.js';
export { SolanaWalletConnector } from './connector/SolanaWalletConnector.js';
import './rpc/RpcProviderSolana/RpcProviderSolana.js';
export * from '@dynamic-labs/rpc-providers';
export { solanaProvidersSelector } from './rpc/solanaProvidersSelector/solanaProvidersSelector.js';
export { SolanaUiTransaction } from './utils/SolanaUiTransaction/SolanaUiTransaction.js';
export { decodeTransactionFromBase64 } from './utils/decodeTransactionFromBase64/decodeTransactionFromBase64.js';
export { isVersionedTransaction } from './utils/isVersionedTransaction/isVersionedTransaction.js';
export { encodeTransactionToBase64 } from './utils/encodeTransactionToBase64/encodeTransactionToBase64.js';
export { getGenesisHashLSKey } from './utils/getGenesisHashLSKey/getGenesisHashLSKey.js';
export { isTxAlreadySigned } from './utils/isTransactionSigned/isTransactionSigned.js';
export { SolanaWallet } from './wallet/SolanaWallet.js';
export { isSolanaWallet } from './wallet/isSolanaWallet/isSolanaWallet.js';
export { isLedgerSolanaWallet } from './wallet/isLedgerSolanaWallet/isLedgerSolanaWallet.js';
export { SOLANA_GENESIS_HASH } from './constants.js';

assertPackageVersion('@dynamic-labs/solana-core', version);
